import { TFunction } from 'i18next'
import { passwordSchema } from 'shared/schemas/password.schema'
import { z } from 'zod'

export const getSetPasswordSchema = (t: TFunction<'auth', 'set_password'>) =>
  z
    .object({
      password: passwordSchema,
      repeatPassword: passwordSchema,
      terms: z.boolean().refine(Boolean, {
        message: t('validation.accept_terms')
      })
    })
    .refine(data => data.password === data.repeatPassword, {
      message: t('validation.passwords_do_not_match'),
      path: ['repeatPassword']
    })
